// Import de bibliotecas principais
import React, { Fragment, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { setLayout } from '../utils/redux/reducers/layout-slice'

import { data as wordpressData } from '../utils/wordpress/wordpressGetter'

// Framer-Motion
import { motion } from 'framer-motion/dist/framer-motion'

// PathHead para SEO, tratamento de página de 404 e página de loading
import { PathHead } from './PathHead'
import { ErrorPath } from './misc'

// Modelos de página existentes para post-types e taxonomias
import * as PostTypes from './post-types'
import * as Taxonomies from './taxonomies'

// Wrapper do Template
const TemplateWrapper = React.forwardRef(({ children, slug }, ref) => {
	return (
		<Fragment>
			<motion.main
				ref={ref}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				id={slug}
			>
				{children}
			</motion.main>
		</Fragment>
	)
})

// Template de Erro
const ErrorTemplate = () => {
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(
			setLayout({
				header: 'Header',
				footer: 'Footer',
				id: null,
				slug: '404',
				type: 'Page',
			})
		)
	})

	return (
		<Fragment>
			<PathHead uri="" />
			<TemplateWrapper slug="notFound">
				<ErrorPath />
			</TemplateWrapper>
		</Fragment>
	)
}

// Template de Loading
// const LoadingTemplate = () => (
// 	<TemplateWrapper slug="">
// 		<LoadingPath />
// 	</TemplateWrapper>
// )

// Componente de exportação
export function PathTemplate({ uri }) {
	const ref = useRef()
	const dispatch = useDispatch()

	let Render
	const data = wordpressData.data

	useEffect(() => {
		if (!Render) return
		if (!data.nodeByUri) return

		let pathInfo = {
			id: data.nodeByUri.id,
			slug: data.nodeByUri.slug,
			type: data.nodeByUri.__typename,
			uri,
		}

		dispatch(
			setLayout(
				Render.layout
					? {
							header: Render.layout.header ?? 'Header',
							footer: Render.layout.footer ?? 'Footer',
							...pathInfo,
					  }
					: { header: 'Header', footer: 'Footer', ...pathInfo }
			)
		)
	})

	if (!data.nodeByUri) return <ErrorTemplate />

	Render = data.nodeByUri.template
		? PostTypes[data.nodeByUri.__typename][
				data.nodeByUri.template.templateName
		  ]
		: Taxonomies[data.nodeByUri.__typename]

	if (!Render) return <ErrorTemplate />

	return (
		<Fragment>
			<PathHead uri={uri} type={data.nodeByUri.__typename} />
			<TemplateWrapper ref={ref} slug={data.nodeByUri.slug}>
				<Render
					path={{
						slug: data.nodeByUri.slug,
						id: data.nodeByUri.id,
						type: data.nodeByUri.__typename,
						refMain: ref,
					}}
				/>
			</TemplateWrapper>
		</Fragment>
	)
}
